import React, {Component} from 'react';
import SubmitButton from "../submitButton";
import Dialog from "../dialog";
import {bindActionCreators} from "redux";
import {sendForm} from "../../thunks";
import connect from "react-redux/es/connect/connect";
import PropTypes from 'prop-types';

class Error extends Component {

    render() {
        const body =
            <div className="Error">
                <p>{'Vyskytl se problém při odesílání Vašeho hodnocení, zkuste ho prosím znovu odeslat.'}</p>
                <SubmitButton
                    onClick={this.props.sendForm.bind(this, this.props.hash)}
                />
            </div>;

        return <Dialog title={'Při odesílání hodnocení došlo k chybě'} body={body} />;
    }

}

Error.propTypes = {
  hash: PropTypes.string.isRequired,
};

const mapStateToProps = ({router, voter}) => ({

});

const mapDispatchToProps = dispatch => bindActionCreators({
    sendForm,
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Error);



// WEBPACK FOOTER //
// ./src/components/error/index.js